import { c as _c } from "react/compiler-runtime";
import { LINKS } from '@/constants/links';
import { useTranslation } from 'react-i18next';
import { useEffectOnce } from 'react-use';
export function CareerConsolePromotion() {
  const $ = _c(2);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] !== t) {
    t0 = () => {
      if (process.env.NODE_ENV === "development") {
        return;
      }
      const link = process.env.NEXT_PUBLIC_BASE_URL + LINKS().career;
      console.log(`%c${t("consolePromo.1")}`, "background: bg-green-600; color: text-white; padding: 4px; border-radius: 2px;", t("consolePromo.2", {
        link
      }));
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffectOnce(t0);
  return null;
}